import { render } from "./bag.svg?vue&type=template&id=7e32ab90"
const script = {}

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__